import { shallowRef } from 'vue'

// How long a spotlight stays before it fades by itself
const SPOTLIGHT_DURATION_MS = 4000

// The elements in the spotlight; SpotlightHost (mounted in App.vue) draws a ring around each
const elements = shallowRef<HTMLElement[]>([])

let timeout: ReturnType<typeof setTimeout> | undefined

const clear = () => {
  clearTimeout(timeout)
  elements.value = []
}

// Rings the elements for a few seconds, replacing any earlier spotlight, after scrolling
// the first one into view. Pointing only: the elements are not focused or clicked.
const spotlight = (targets: HTMLElement[]) => {
  clear()
  if (!targets.length) return
  targets[0].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' })
  elements.value = targets
  timeout = setTimeout(clear, SPOTLIGHT_DURATION_MS)
}

export const spotlightState = { elements, clear }

export const useSpotlight = () => ({ spotlight, clear })
